import React from "react";

import "./Loader.scss";
/**
 * Loader function component
 * Loading animation with three scaling dots
 * @param className
 * @param ariaLabel description for blind people
 * @param size xsmall, small, medium, large or xlarge. use any other string to define the size by setting / inheriting a fontsize
 * @param theme primary, secondary or ui
 * @param props
 */
export default function Loader({
                                   className = "",
                                   ariaLabel = "Loading",
                                   size = "medium",
                               }) {
    let classnames = (...args) => {
        return args.filter(str => typeof str === "string").join(" ");
    }

    const classes = classnames(
        "loader-animation",
        `loader-animation--size-${size}`,
        className
    );
    // template rendering
    return (
        <div className={classes} aria-label={ariaLabel}>
            {[...Array(3)].map((x, i) => {
                return (
                    <span
                        className={`loader__item loader__item--n-${i}`}
                        key={`loader--key-${i}`}
                        aria-hidden={true}
                    />
                );
            })}
        </div>
    );
}
